import { Accordion, AccordionSection } from '@slal/ui/display';
import { Article, Ul } from '@slal/ui/typography';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from '~/hooks';
import { Li, Text } from '../Typography';
import { assumptionsContent } from './utils';

export const Assumptions = () => {
    const { pushEvent } = useAnalytics();
    const { pathname } = useLocation();

    const accordionTitle = 'Assumptions we make';
    return (
        <Accordion key={pathname}>
            <AccordionSection
                id="assumptions-accordion"
                title={accordionTitle}
                onOpen={() => pushEvent({ eventLabel: `${accordionTitle} - opened` })}
            >
                <Article>
                    <Text weight="bold">How we've calculated the future value of your pension plan</Text>
                    <Ul>
                        {assumptionsContent.map((item, index) => (
                            <Li key={`assumption-${index}`}>{item}</Li>
                        ))}
                    </Ul>
                </Article>
            </AccordionSection>
        </Accordion>
    );
};
